import * as React from 'react';
import LazyLoad from 'react-lazyload';
import AppConfig from '../AppConfig';
import { makeImageLink } from '../utils/image';
function EntityImage({ entity, usePlaceholder = false, height = 100, offset = 100, transform, thumbTransform = 'w_40,h_40,c_fill', ...rest }) {
    const imageProps = {
        title: entity.title,
        alt: entity.title,
        ...rest,
    };
    return (React.createElement(AppConfig, null, ({ imageHost }) => {
        const thumbUrl = entity.image && makeImageLink({
            host: imageHost,
            image: entity.image,
            transform: thumbTransform,
        });
        const imageUrl = entity.image && makeImageLink({
            host: imageHost,
            image: entity.image,
            transform,
        });
        return (React.createElement(LazyLoad, { height: height, offset: offset, once: true, placeholder: usePlaceholder && React.createElement("img", Object.assign({ src: thumbUrl }, imageProps)) },
            React.createElement("img", Object.assign({ src: imageUrl }, imageProps))));
    }));
}
export default EntityImage;
//# sourceMappingURL=index.js.map